module.exports = __webpack_public_path__ + "static/media/provozovna (5).3bcd1cd2.png";